import React, { useState, useEffect } from "react";
import api from "../../services/api";

const FIELD =
  "mb-3 w-full rounded-lg border border-stone-300 bg-stone-100 p-3 text-stone-500 placeholder:text-stone-400 dark:border-slate-700 dark:bg-slate-800 dark:text-white";
const LABEL = "text-sm font-medium text-stone-700 dark:text-slate-300";

const today = () => new Date().toISOString().substring(0, 10);
const asDateInput = (value) => (value ? String(value).substring(0, 10) : "");

/**
 * The single vaccin form, shared by the dialog on desktop and the
 * /nouveau_vaccin and /modifier_vaccin routes on mobile.
 *
 * Pass `vaccineId` to edit an existing record, omit it to create a new one.
 */
function VaccineForm({ calfID, vaccineId, onDone, onCancel }) {
  const isEdit = Boolean(vaccineId);

  const [date, setDate] = useState(today());
  const [name, setName] = useState("");
  const [isSaving, setSaving] = useState(false);

  useEffect(() => {
    if (!isEdit) return;

    api
      .get("/vaccine/" + vaccineId)
      .then((response) => {
        setDate(asDateInput(response.data.date) || today());
        setName(response.data.name || "");
      })
      .catch((error) => {
        console.error("There was an error fetching the vaccine!", error);
      });
  }, [isEdit, vaccineId]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSaving(true);

    const payload = { date: date, name: name, fk_calf: calfID };
    const request = isEdit
      ? api.put("/vaccine/" + vaccineId, { ...payload, pk_vaccine: vaccineId })
      : api.post("/vaccine", payload);

    request
      .then(() => onDone())
      .catch((error) => {
        console.error("There was an error saving the vaccine!", error);
        setSaving(false);
      });
  };

  return (
    <form onSubmit={handleSubmit} className="flex w-full flex-col">
      <label htmlFor="vaccine_name_input" className={LABEL}>
        Nom du vaccin
      </label>
      <input
        className={FIELD}
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Nom du vaccin"
        name="vaccine_name_input"
      />

      <label htmlFor="vaccine_date_input" className={LABEL}>
        Date du vaccin
      </label>
      <input
        className={FIELD}
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        name="vaccine_date_input"
      />

      <button
        type="submit"
        disabled={isSaving}
        className="my-3 w-full rounded-lg bg-amber-400 p-3 font-medium text-white disabled:opacity-50 dark:bg-amber-600"
      >
        {isEdit ? "Enregistrer" : "Ajouter"}
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="mb-3 w-full rounded-lg border border-stone-300 p-3 text-sm text-stone-500 hover:text-amber-500 dark:border-slate-700 dark:text-slate-300"
      >
        Annuler
      </button>
    </form>
  );
}

export default VaccineForm;
